/** Application-wide enumerations. Values are stored in the database as-is. */
export const USER_ROLES = ['admin', 'field_staff'];
export const LOCALES = ['it', 'tr'];
export const DEFAULT_LOCALE = 'it';
/** Server stores UTC; every UI renders in this zone. */
export const DISPLAY_TIMEZONE = 'Europe/Rome';
export const CURRENCY = 'EUR';
/** Unit of measure for products. */
export const PRODUCT_UNITS = ['piece', 'case', 'kg', 'liter'];
/** Italian IVA rates available by default; editable from settings. */
export const DEFAULT_VAT_RATES = [4, 5, 10, 22];
export const ROUTE_STATUSES = ['draft', 'assigned', 'started', 'completed'];
export const ROUTE_STOP_STATUSES = ['pending', 'visited', 'skipped'];
export const STOP_SKIP_REASONS = [
    'customer_closed',
    'no_order',
    'out_of_time',
    'other',
];
export const DOCUMENT_TYPES = ['sale', 'return', 'exchange'];
export const DOCUMENT_STATUSES = ['active', 'cancelled'];
/** A line is either goods going out (sale) or coming back (return). */
export const DOCUMENT_LINE_KINDS = ['sale', 'return'];
export const RETURN_REASONS = ['expired', 'damaged', 'unsold', 'other'];
export const PAYMENT_METHODS = ['cash', 'cheque', 'bank_transfer', 'card'];
/** Customer ledger: debit increases what the customer owes, credit reduces it. */
export const LEDGER_DIRECTIONS = ['debit', 'credit'];
export const LEDGER_SOURCES = ['document', 'document_cancellation', 'payment', 'adjustment'];
/** Where stock physically sits. */
export const STOCK_LOCATION_KINDS = ['warehouse', 'vehicle'];
/**
 * Stock movement reasons. Every quantity change is an append-only movement;
 * the on-hand quantity for a product at a location is the sum of its movements,
 * never a stored counter.
 */
export const STOCK_MOVEMENT_TYPES = [
    'purchase_in', // supplier -> warehouse
    'transfer_out', // warehouse -> vehicle (loading)
    'transfer_in', // vehicle -> warehouse (unloading)
    'sale_out', // vehicle -> customer
    'return_in', // customer -> vehicle
    'adjustment', // manual correction (count, loss, breakage)
    'write_off', // discarded (expired, damaged)
];
export const MAP_PROVIDERS = ['osm', 'google'];
/**
 * Location sample phase relative to the route session.
 *
 * `on_route` is between starting and finishing a route. `on_shift` is anything
 * outside that while the driver is working, which the owner asked for (D76) and
 * which `settings.tracked_phases` must explicitly allow — its default is
 * `['on_route']` alone, so nothing wider is recorded by deploying.
 */
export const TRACKING_PHASES = ['on_route', 'on_shift'];
export const SETTINGS_DEFAULTS = {
    mapProvider: 'osm',
    osmTileUrl: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    deviationDistanceMeters: 300,
    deviationMinDurationSeconds: 300,
    locationIntervalSeconds: 15,
    locationDistanceMeters: 25,
    locationAccuracyLimitMeters: 50,
    defaultGeofenceRadiusMeters: 100,
    locationRetentionDays: 180,
    /**
     * Narrow on purpose. Widening this to include `on_shift` is a decision an
     * organisation has to be able to justify under Statuto dei Lavoratori art. 4,
     * so it is a deliberate change by an administrator, never a default.
     */
    trackedPhases: ['on_route'],
    allowStaffPriceOverride: false,
    vatRates: [...DEFAULT_VAT_RATES],
};
export const PAGINATION = {
    defaultPageSize: 25,
    maxPageSize: 200,
};
//# sourceMappingURL=index.js.map